// getters
export const GETTERS_LIST_PROGRAM = "GETTERS_LIST_PROGRAM";
export const GETTERS_LIST_ALL_PROGRAM = "GETTERS_LIST_ALL_PROGRAM";
export const GETTERS_LIST_PROGRAM_CLIENTS = "GETTERS_LIST_PROGRAM_CLIENTS";
export const GETTERS_PROGRAM_DETAIL = "GETTERS_PROGRAM_DETAIL";
export const GETTERS_CURRENT_PROGRAM_STATUS = "GETTERS_CURRENT_PROGRAM_STATUS";
export const GETTERS_PROGRAMS_PAGINATION = "GETTERS_PROGRAMS_PAGINATION";

// action
export const ACTION_GET_PROGRAM_LIST = "ACTION_GET_PROGRAM_LIST";
export const ACTION_GET_PROGRAM_LIST_RAW = "ACTION_GET_PROGRAM_LIST_RAW";
export const ACTION_GET_ALL_PROGRAM_LIST = "ACTION_GET_ALL_PROGRAM_LIST";
export const ACTION_DELETE_PROGRAM = "ACTION_DELETE_PROGRAM";
export const ACTION_ADD_PROGRAM = "ACTION_ADD_PROGRAM";
export const ACTION_EDIT_PROGRAM = "ACTION_EDIT_PROGRAM";
export const ACTION_GET_PROGRAM = "ACTION_GET_PROGRAM";
export const ACTION_GET_CURRENT_PROGRAM_STATUS = "ACTION_GET_CURRENT_PROGRAM_STATUS";
export const ACTION_SET_EMPTY_PROGRAM = "ACTION_SET_EMPTY_PROGRAM";
export const ACTION_SET_PROGRAM = "ACTION_SET_PROGRAM";
export const ACTION_SET_CLIENT_PROGRAM = "ACTION_SET_CLIENT_PROGRAM";
export const ACTION_CONVERT_LIST_EMPLOYER_TO_LIST_CLIENT =
  "ACTION_CONVERT_LIST_EMPLOYER_TO_LIST_CLIENT";
export const ACTION_SET_PROGRAM_LIST = "ACTION_SET_PROGRAM_LIST";
export const ACTION_EXPORT_PROGRAM_TEMPLATE = "ACTION_EXPORT_PROGRAM_TEMPLATE";
export const ACTION_CLONE_PROGRAM = "ACTION_CLONE_PROGRAM";
export const ACTION_GET_PROGRAM_TEMPLATE_LIST =
  "ACTION_GET_PROGRAM_TEMPLATE_LIST";
export const ACTION_GET_PROGRAM_TEMPLATE_LIST_RAW =
  "ACTION_GET_PROGRAM_TEMPLATE_LIST_RAW";
export const ACTION_EXPORT_CSV = "ACTION_EXPORT_CSV";
export const ACTION_EXTRACT_CONSENT_DETAILS =
  "ACTION_EXTRACT_CONSENT_DETAILS";
export const ACTION_UPDATE_PROGRAM_SUBGROUP = "ACTION_UPDATE_PROGRAM_SUBGROUP";
export const ACTION_PREVIEW_HPSF = "ACTION_PREVIEW_HPSF";
export const ACTION_GET_HPSF_FORM_TYPE_LIST = "ACTION_GET_HPSF_FORM_TYPE_LIST";
// mutation
export const MUTATION_SET_PROGRAM_LIST = "MUTATION_SET_PROGRAM_LIST";
export const MUTATION_SET_ALL_PROGRAM_LIST = "MUTATION_SET_ALL_PROGRAM_LIST";
export const MUTATION_SET_PROGRAM = "MUTATION_SET_PROGRAM";
export const MUTATION_SET_CURRENT_PROGRAM_STATUS = "MUTATION_SET_CURRENT_PROGRAM_STATUS";
export const MUTATION_SET_CLIENT_PROGRAM = "MUTATION_SET_CLIENT_PROGRAM";
export const MUTATION_SET_PROGRAM_CLIENTS_LIST =
  "MUTATION_SET_PROGRAM_CLIENTS_LIST";
export const MUTATION_SET_CONSENT_DETAILS_LIST = "MUTATION_SET_CONSENT_DETAILS_LIST";

// program status
export const PROGRAM_STATUS = {
  ACTIVE: "Active",
  DRAFT: "Draft",
  QA_VERIFY: 'QA Verify',
  COMPLETED: "Completed",
  CANCELLED: "Cancelled"
};

// program level structure
export const PROGRAM_LEVEL_STRUCTURE = {
  NO_POINTS: "No Points",
  LINEAR: "Linear",
  EXPONENTIAL: "Exponential",
  CUSTOM: "Custom"
};

// program requirement items
export const PROGRAM_REQUIREMENT_ITEMS = {
  ACTIVITY: "ACTIVITY",
  PATH: "PATH",
  TYPE_OF_ITEM: {
    TOBACCO_ATTESTATION: "TOBACCO_ATTESTATION"
  }
};

export const PROGRAM_TYPES = {
  PARTICIPANT_PROGRAM: "PARTICIPANT_PROGRAM",
  FULL_OUTCOMES: "FULL_OUTCOMES",
  OUTCOMES_LITE: "OUTCOMES_LITE"
}

export const ONSITE_SCREENING_TYPE = {
  CONNECTWELL_10: "Connectwell 1.0 Scheduler",
  CONNECTWELL_20: "Connectwell 2.0 Scheduler",
}

export const SAVING_PROGRAM_ERROR = {

  INVALID_END_DATE: {
    key: "dateRange",
    message: "The end date is not empty or before the start date."
  },
  LABCORP_ACCOUNT_NUMBER_INVALID: {
    key: "LabcorpAccountNumber",
    message: "LabCorp account number in use for a different client account"
  }
}

export const SCREENING_SELECTIONS = {
  QUEST: "QUEST",
  E_HEALTH_SCREENING: "E_HEALTH_SCREENING"
}



// WEBPACK FOOTER //
// ./src/store/modules/basic_programs/constants.js